import React from "react";
import Article from "../../../../entities/article";
import ArticleBoxThumbnail from "../../../../components/ArticleBoxThumbnail";
import {
  buildAuthorTag,
  CATEGORY_ICONS,
  buildPortalBadges,
} from "../common/portalArticleBox";
import PortalBookmarkButtons from "../common/PortalBookmarkButtons";

type Props = {
  article: Article;
  company_name: string;
  company_name_ja: string;
};

function PortalPCArticleBox({ article, company_name, company_name_ja }: Props) {
  const imageUrl = article.medium_pic_url
    ? article.medium_pic_url.replace("medium_fill", "large_fill")
    : undefined;
  const userIconUrl = article.user?.icon_url;
  const labels = buildPortalBadges(article);
  const tagNames = article.tag_names_for_ab();
  const authorTag = buildAuthorTag(article.author_tag, company_name_ja);
  // NOTE: SSRとhydrateで一致させるため、useIdではなくarticle.id由来の決定的なidにする
  const titleId = `portalArticleBoxTitle${article.id}`;

  return (
    <div
      className={article.pickup ? "jsPickupArticle" : "jsArticleWithoutPickup"}
    >
      <article
        className={`m_portalArticleBox jsResultBox jsArticle${article.id} ${
          article.pickup ? "isPickup" : ""
        }`}
        aria-labelledby={titleId}
      >
        <div className="portalArticleBoxContent">
          <div className="portalArticleBoxLabelRow">
            <ul className="portalArticleBoxLabels">
              {labels.map((label) => (
                <li
                  key={label.text}
                  className={`p_nonLinkTag ${label.modifier}`}
                >
                  {label.text}
                </li>
              ))}
            </ul>
            {article.updated_date && (
              <span className="portalArticleBoxPostedAt">
                {article.updated_date}
              </span>
            )}
            {authorTag && (
              <div
                className={`portalArticleBoxAuthorTag ${authorTag.modifier}`}
              >
                <i className="fa fa-flag" aria-hidden="true" />
                {authorTag.text}
              </div>
            )}
          </div>

          <h3 className="portalArticleBoxTitle" id={titleId}>
            <a href={article.companies_path(company_name)}>{article.title}</a>
          </h3>
          {article.description && (
            <p className="portalArticleBoxDescription">{article.description}</p>
          )}

          <div className="portalArticleBoxBody">
            <div className="portalArticleBoxThumb">
              {imageUrl || userIconUrl ? (
                <ArticleBoxThumbnail
                  imageUrl={imageUrl}
                  userIconUrl={userIconUrl}
                  effect="opacity"
                  showUserIconBackground={false}
                />
              ) : (
                <div className="p_defaultThumbnail" />
              )}
            </div>
            <div className="portalArticleBoxDetail">
              <div className="portalArticleBoxOrgName">
                {article.user_name()}
              </div>
              <ul className="portalArticleBoxInfoList">
                {Article.category_labels_for_sp().map(
                  (cat) =>
                    (article as any)[cat] && (
                      <li key={cat} className="portalArticleBoxInfoItem">
                        <i
                          className={`fa ${CATEGORY_ICONS[cat]} portalArticleBoxInfoIcon`}
                          aria-hidden="true"
                        />
                        <span
                          className="portalArticleBoxInfoText"
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: article.category_names(cat),
                          }}
                        />
                      </li>
                    )
                )}
              </ul>
            </div>
          </div>

          {tagNames.length !== 0 && (
            <ul className="portalArticleBoxTagList">
              {tagNames.map((name) => (
                <li key={name} className="p_nonLinkTag">
                  {name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="portalArticleBoxButtons">
          <a
            href={article.companies_path(company_name)}
            className="p_btnLarge isMain"
            aria-label={`${article.title}の詳細を見る`}
          >
            詳細を見る
          </a>
          <PortalBookmarkButtons
            articleId={article.id!}
            articleTitle={article.title}
          />
        </div>

        {article.pickup && article.pickup.comment && (
          <div className="portalPickupComment">
            <h3 className="portalPickupCommentHeading">PICKUP COMMENT</h3>
            <p className="portalPickupCommentText">{article.pickup.comment}</p>
            <div className="portalPickupCommentEditor">
              編集：
              {article.pickup.is_pickup_by_activo
                ? "株式会社activo(ボランティアポータル委託先)"
                : company_name_ja}
              担当者
            </div>
          </div>
        )}
      </article>
    </div>
  );
}

export default PortalPCArticleBox;
